module.exports = __webpack_public_path__ + "img/20250417_5.21324a04.jpg";